<div class="preferences-content">
  <div class="preferences-title">
    <span class="title">Settings</span>
  </div>

  <!--Sort By-->
  <ion-list *ngIf="isHomePage" class="list">
    <ion-list-header class="header">
      <ion-label class="header-label">Sort By:</ion-label>
    </ion-list-header>

    <ion-radio-group class="group">
      <ion-item class="item">
        <ion-radio value="date"
          checked
          [disabled]="!isListView"
          class="radio">
        </ion-radio>
        <ion-label class="label">
          <i class="far fa-calendar-check icon"></i>
          <span>Release Date</span>
        </ion-label>
      </ion-item>

      <ion-item class="item">
        <ion-radio value="artist"
          [disabled]="!isListView"
          class="radio">
        </ion-radio>
        <ion-label class="label">
          <i class="fas fa-user-plus icon"></i>
          <span>Artist</span>
        </ion-label>
      </ion-item>
    </ion-radio-group>
  </ion-list>

  <!--Channel Preferences | Account Settings-->
  <ion-list class="list">
    <div class="group">
      <button *ngIf="isHomePage" [disabled]="!isHomePage"
        class="button">
        <i class="fas fa-cubes icon"></i>
        <span>Channel Preferences</span>
      </button>

      <button
        (click)="goToPage('account-settings')"
        class="button">
        <i class="fas fa-user-cog icon"></i>
        <span>Account Settings</span>
      </button>

      <button
        *ngIf="isApp"
        (click)="goToPage('settings/application-settings')"
        class="button">
        <i class="fas fa-cogs icon"></i>
        <span>Application Settings</span>
      </button>
    </div>
  </ion-list>

  <!--"Terms & Condition" & "Privacy Policy"-->
  <ion-list class="list">
    <div class="group">
      <button
        (click)="openTerms()"
        class="button preference-link">
        <i class="fas fa-external-link-alt icon"></i>
        <span>Terms & Conditions</span>
      </button>

      <button
        (click)="openPrivacy()"
        class="button preference-link">
        <i class="fas fa-external-link-alt icon"></i>
        <span>Privacy Policy</span>
      </button>

      <button
        (click)="onHelpClick()"
        class="button preference-link">
        <i class="far fa-question-circle icon"></i>
        <span>Help</span>
      </button>
    </div>
  </ion-list>

  <!--Sign Out-->
  <ion-list class="list">
    <div class="group non-line">
      <button (click)="onSignOutClick()"
        class="button">
        <i class="fas fa-sign-out-alt icon"></i>
        <span>Log Out</span>
      </button>
    </div>
  </ion-list>
</div>
